import theme from '@theme-ui/preset-tailwind';

export const messages = {
  ...(theme.messages && theme.messages),
};
